import React from "react";
import { Menu } from "lucide-react";
import { cn } from "../../../lib/utils";

export default function PageHeader({ setNavigationExpanded, pageTitle, className = "" }) {
  return (
    <div className={cn(
      // Base styles
      "relative w-full h-[63px] bg-white border-b border-gray-300/30",
      "flex flex-row items-center justify-between px-12",
      // Mobile and portrait styles  
      "mobile-max:border-t mobile-max:border-t-gray-300/30 mobile-max:px-4 mobile-max:w-full",
      "portrait:border-t portrait:border-t-gray-300/30 portrait:px-4 portrait:w-full",
      className
    )}>
      <div>{pageTitle}</div>
      <div
        className={cn(
          // Hide by default
          "hidden",
          // Show on mobile and portrait
          "mobile-max:flex mobile-max:items-center mobile-max:justify-center",
          "mobile-max:absolute mobile-max:bottom-3 mobile-max:right-2.5",
          "mobile-max:cursor-pointer mobile-max:w-[34px] mobile-max:h-[34px]",
          "mobile-max:rounded-full mobile-max:hover:bg-gray-100",
          "mobile-max:hover:outline-1 mobile-max:hover:outline-gray-600/20",
          "portrait:flex portrait:items-center portrait:justify-center",
          "portrait:absolute portrait:bottom-3 portrait:right-2.5",
          "portrait:cursor-pointer portrait:w-[34px] portrait:h-[34px]",
          "portrait:rounded-full portrait:hover:bg-gray-100",
          "portrait:hover:outline-1 portrait:hover:outline-gray-600/20"
        )}
        onClick={() => setNavigationExpanded(true)}
      >
        <Menu size={20} />
      </div>
    </div>
  );
}
